import { px2mm } from '@/utils';

function round(value: number, precision: number) {
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

export const calculatePrintArea = (
  dpi: number,
  positions: any[],
  shapes: any[]
): { width: number; height: number } => {
  let lowestX = 0;
  let lowestY = 0;
  let highestX = 0;
  let highestY = 0;

  shapes.map((shape: any) => {
    const currentShape = positions.find((pos: any) => {
      return shape.id === pos.logoId;
    });

    if (currentShape) {
      const height = px2mm(shape.height as number, dpi);
      const width = px2mm(shape.width as number, dpi);
      const rotation = shape.rotation as number;
      const shapeX = px2mm(shape.x as number, dpi);
      const shapeY = px2mm(shape.y as number, dpi);

      const heightWithRotation =
        height * Math.abs(Math.cos(rotation)) +
        width * Math.abs(Math.sin(rotation)); // Obican height ili kada se zarotira

      const widthWithRotation =
        width * Math.abs(Math.cos(rotation)) +
        height * Math.abs(Math.sin(rotation)); // Obican width ili kada se zarotira

      // This is y
      const distanceFromTop = shapeY - (heightWithRotation - height) / 2;
      // This is x
      const distanceFromLeft = shapeX - (widthWithRotation - width) / 2;

      if (lowestX == 0) {
        lowestX = distanceFromLeft;
      } else {
        if (distanceFromLeft < lowestX) {
          lowestX = distanceFromLeft;
        }
      }

      if (lowestY == 0) {
        lowestY = distanceFromTop;
      } else {
        if (distanceFromTop < lowestY) {
          lowestY = distanceFromTop;
        }
      }

      if (distanceFromLeft + widthWithRotation > highestX) {
        highestX = distanceFromLeft + widthWithRotation; // This is width
      }

      if (distanceFromTop + heightWithRotation > highestY) {
        highestY = distanceFromTop + heightWithRotation; // This is height
      }
    }
  });
  return {
    width: round(highestX - lowestX, 1),
    height: round(highestY - lowestY, 1),
  };
};

export const calculatePrintAreaV2 = (
  positions: any[],
  shapes: any[]
): { width: number; height: number } => {
  let lowestX = 0;
  let lowestY = 0;
  let highestX = 0;
  let highestY = 0;

  shapes.map((shape: any) => {
    const currentShape = positions.find((pos: any) => {
      return shape.id === pos.logoId;
    });

    if (currentShape) {
      const height = shape.heightOnProductMM;
      const width = shape.widthOnProductMM;
      const rotation = shape.rotation as number;
      const shapeX = shape.xOnProductMM;
      const shapeY = shape.yOnProductMM;

      const heightWithRotation =
        height * Math.abs(Math.cos(rotation)) +
        width * Math.abs(Math.sin(rotation)); // Obican height ili kada se zarotira

      const widthWithRotation =
        width * Math.abs(Math.cos(rotation)) +
        height * Math.abs(Math.sin(rotation)); // Obican width ili kada se zarotira

      // This is y
      const distanceFromTop = shapeY - (heightWithRotation - height) / 2;
      // This is x
      const distanceFromLeft = shapeX - (widthWithRotation - width) / 2;

      if (lowestX == 0) {
        lowestX = distanceFromLeft;
      } else {
        if (distanceFromLeft < lowestX) {
          lowestX = distanceFromLeft;
        }
      }

      if (lowestY == 0) {
        lowestY = distanceFromTop;
      } else {
        if (distanceFromTop < lowestY) {
          lowestY = distanceFromTop;
        }
      }

      if (distanceFromLeft + widthWithRotation > highestX) {
        highestX = distanceFromLeft + widthWithRotation; // This is width
      }

      if (distanceFromTop + heightWithRotation > highestY) {
        highestY = distanceFromTop + heightWithRotation; // This is height
      }
    }
  });
  return {
    width: round(highestX - lowestX, 1),
    height: round(highestY - lowestY, 1),
  };
};
